import { createEntityAdapter } from '@reduxjs/toolkit';
import ILocation from 'types/company/locations/ILocation';

const locationsAdapter = createEntityAdapter<ILocation>({
  selectId: location => location.id,
});

export default locationsAdapter;
